const strings: Record<string, Record<string, string>> = {
  en: {
    "input.placeholder": "Type a message...",
    "csat.question": "Was this helpful?",
    "csat.thanks": "Thanks for your feedback!",
    "prechat.submit": "Start chatting with {botName}",
    "prechat.skip": "Skip for now",
    "prechat.required": "This field is required",
    "prechat.invalidEmail": "Enter a valid email address",
    "prechat.blockedEmail": "Please use a different email address",
    "prechat.invalidPhone": "Enter a valid phone number",
    "farewell.thanks": "Thank you for connecting with us.",
    "error.generic": "Sorry, something went wrong. Please try again.",
    "error.timeout": "That took too long. Please try again.",
    "error.retry": "Retry",
  },
  hi: {
    "input.placeholder": "संदेश लिखें...",
    "csat.question": "क्या यह सहायक था?",
    "csat.thanks": "आपकी प्रतिक्रिया के लिए धन्यवाद!",
    "prechat.submit": "{botName} से चैट शुरू करें",
    "prechat.skip": "अभी के लिए छोड़ें",
    "prechat.required": "यह फ़ील्ड आवश्यक है",
    "prechat.invalidEmail": "मान्य ईमेल पता दर्ज करें",
    "prechat.blockedEmail": "कृपया कोई दूसरा ईमेल पता उपयोग करें",
    "prechat.invalidPhone": "मान्य फ़ोन नंबर दर्ज करें",
    "farewell.thanks": "हमसे जुड़ने के लिए धन्यवाद।",
    "error.generic": "क्षमा करें, कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
    "error.timeout": "इसमें बहुत समय लग गया। कृपया पुनः प्रयास करें।",
    "error.retry": "पुनः प्रयास करें",
  },
};

export function t(
  key: string,
  lang: string,
  vars?: Record<string, string>
): string {
  const dict = strings[lang] ?? strings.en;
  let str = dict[key] ?? strings.en[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replace(`{${k}}`, v);
    }
  }
  return str;
}
